import React, { useEffect, useState } from "react";

interface TravelAgency {
  name: string;
  address: string;
  website: string;
  rating: number;
}

const TravelCMS: React.FC = () => {
  const [agencies, setAgencies] = useState<TravelAgency[]>([]);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    fetch("/data/travel.json")
      .then((res) => res.json())
      .then((data) => {
        setAgencies(data.agencies || []);
      })
      .catch(() => {
        setError("Failed to load travel data.");
      });
  }, []);

  const handleChange = <K extends keyof TravelAgency>(
    index: number,
    field: K,
    value: string
  ) => {
    const updated = [...agencies];
    updated[index] = {
      ...updated[index],
      [field]: field === "rating" ? parseFloat(value) : value,
    };
    setAgencies(updated);
  };

  const handleDownload = () => {
    const jsonStr = JSON.stringify({ agencies }, null, 2);
    const blob = new Blob([jsonStr], { type: "application/json" });
    const url = URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = "travel-updated.json";
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div className="p-6 max-w-5xl mx-auto" style={{ marginTop: "100px" }}>
      <h1 className="text-2xl font-bold mb-6">Travel Agency CMS</h1>
      {error && <div className="text-red-500 mb-4">{error}</div>}
      {agencies.map((agency, index) => (
        <div
          key={index}
          className="flex flex-col sm:flex-row gap-4 items-center border p-4 mb-3 rounded bg-gray-50"
        >
          <input
            value={agency.name}
            onChange={(e) => handleChange(index, "name", e.target.value)}
            className="border p-2 flex-1 w-full"
            placeholder="Agency Name"
          />
          <input
            value={agency.address}
            onChange={(e) => handleChange(index, "address", e.target.value)}
            className="border p-2 flex-1 w-full"
            placeholder="Address"
          />
          <input
            value={agency.website}
            onChange={(e) => handleChange(index, "website", e.target.value)}
            className="border p-2 flex-1 w-full"
            placeholder="Website"
          />
          <input
            value={agency.rating}
            type="number"
            step="0.1"
            min="0"
            max="5"
            onChange={(e) => handleChange(index, "rating", e.target.value)}
            className="border p-2 w-24"
          />
        </div>
      ))}

      <button
        onClick={handleDownload}
        className="bg-blue-600 text-white px-6 py-2 mt-4 rounded hover:bg-blue-700"
      >
        Download Updated JSON
      </button>
    </div>
  );
};

export default TravelCMS;
